import { __assign, __decorate } from 'tslib';
import { defineInjectable, Injectable, Component, NgModule } from '@angular/core';

var GoogleAnalyticsService = /** @class */ (function () {
    function GoogleAnalyticsService() {
    }
    GoogleAnalyticsService.prototype.injectOptimizeScripts = function (containerId) {
        var optimizeContainerId = 'GTM-M55G5D7';
        if (!containerId) {
            optimizeContainerId = containerId;
        }
        var optimizeHeadScript = document.createElement("script");
        optimizeHeadScript.setAttribute('src', 'https://www.googleoptimize.com/optimize.js?id=' + optimizeContainerId);
        document.head.appendChild(optimizeHeadScript);
    };
    GoogleAnalyticsService.prototype.postGaEvent = function (eventName, event, user) {
        var postMessage = {
            'event': eventName,
            'event_parameters': {
                'form_name': event.form_name,
                'form_action': event.form_action,
                'form_step': event.form_step,
                'lead_id': event.lead_id,
                'product': event.product,
                'event_category': event.event_category,
                'click_text': event.click_text
            },
            'user': user ? {
                'first_name': user.first_name,
                'last_name': user.last_name,
                'phone': user.phone,
                'email': user.email
            } : undefined,
            'sentFrom': 'angular-iframe'
        };
        if (postMessage.event !== 'generate_lead') {
            delete postMessage.user;
        }
        this.postMessage(this.sanitizePostMessage(postMessage));
    };
    GoogleAnalyticsService.prototype.sanitizePostMessage = function (postMessage) {
        var sanitizedPostMessage = __assign({}, postMessage);
        Object.keys(sanitizedPostMessage.event_parameters).forEach(function (key) {
            var value = sanitizedPostMessage.event_parameters[key];
            if (value === null || value === undefined) {
                delete sanitizedPostMessage.event_parameters[key];
            }
        });
        if (sanitizedPostMessage.user) {
            Object.keys(sanitizedPostMessage.user).forEach(function (key) {
                var value = sanitizedPostMessage.user[key];
                if (value === null || value === undefined) {
                    delete sanitizedPostMessage.user[key];
                }
            });
        }
        return sanitizedPostMessage;
    };
    GoogleAnalyticsService.prototype.postMessage = function (postMessage) {
        window.dataLayer = window.dataLayer || [];
        parent.postMessage(__assign({}, postMessage), '*');
        window.dataLayer.push({ 'event': postMessage.event });
    };
    GoogleAnalyticsService.ngInjectableDef = defineInjectable({ factory: function GoogleAnalyticsService_Factory() { return new GoogleAnalyticsService(); }, token: GoogleAnalyticsService, providedIn: "root" });
    GoogleAnalyticsService = __decorate([
        Injectable({
            providedIn: 'root'
        })
    ], GoogleAnalyticsService);
    return GoogleAnalyticsService;
}());

var GoogleAnalyticsComponent = /** @class */ (function () {
    function GoogleAnalyticsComponent() {
    }
    GoogleAnalyticsComponent = __decorate([
        Component({
            selector: 'lib-google-analytics',
            template: "\n    <p>\n      google-analytics works!\n    </p>\n  "
        })
    ], GoogleAnalyticsComponent);
    return GoogleAnalyticsComponent;
}());

var GoogleAnalyticsModule = /** @class */ (function () {
    function GoogleAnalyticsModule() {
    }
    GoogleAnalyticsModule = __decorate([
        NgModule({
            declarations: [GoogleAnalyticsComponent],
            imports: [],
            exports: [GoogleAnalyticsComponent]
        })
    ], GoogleAnalyticsModule);
    return GoogleAnalyticsModule;
}());

/*
 * Public API Surface of google-analytics
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GoogleAnalyticsComponent, GoogleAnalyticsModule, GoogleAnalyticsService };
//# sourceMappingURL=google-analytics.js.map
